import * as Yup from 'yup';

export const confirmPassWordSchema = Yup.object().shape({
    password: Yup.string().required("Insira a senha!").min(3, "").max(30, ""),
});